module.exports = __webpack_public_path__ + "img/icon_map_7_on_001.4c6d1a97.png";